import React, { Component } from "react";
import {NavLink} from 'react-router-dom';
import "./style.css";
import "../../../index.css";
class RankTab extends Component {
  render() {
    const {subjectActive,schoolActive}=this.props;
    return (
      <div className="ranktab_box">
        <NavLink
        to="/rank/subject"
          className={
            subjectActive
              ? "ranktab_subject_active_box fl"
              : "ranktab_subject_box fl"
          }
        >
          学科排名
        </NavLink>
        <NavLink
        to="/rank/school"
          className={
            schoolActive
              ? "ranktab_school_active_box fl"
              : "ranktab_school_box fl"
          }
        >
          大学排名
        </NavLink>
        <div className="clear"></div>
      </div>
    );
  }
}

export default RankTab;



// WEBPACK FOOTER //
// ./src/components/Rank/RankTab/index.js